export default __webpack_public_path__ + "static/media/Thundering Glaive.29ed9578.jpg";